import type {Mapper} from 'framework';
import type {UserReminder} from '../../domain/user-reminder';
import type {ReminderDto} from '../dto/settings.dto';

const toDate = (value: string | Date | null): Date | null => {
  if (value === null) {
    return null;
  }
  return value instanceof Date ? value : new Date(value);
};

export class ReminderDtoToUserReminderMapper implements Mapper<ReminderDto, UserReminder> {
  transform(dto: ReminderDto): UserReminder {
    return {
      id: dto.id,
      kind: dto.kind,
      interval: dto.interval,
      weekdays: dto.weekdays,
      enabled: dto.enabled,
      lastAcknowledgedAt: toDate(dto.lastAcknowledgedAt),
    };
  }
}
